/**
 * app.js
 *
 * This is the entry file for the application, only setup and boilerplate
 * code.
 */

// Needed for ES6 generator/async support
import 'regenerator-runtime/runtime';
import React from 'react';
import { createRoot } from 'react-dom/client';
import { ApolloProvider } from '@apollo/client';
import { Provider } from 'react-redux';
import { ConnectedRouter } from 'connected-react-router/immutable';
import 'sanitize.css/sanitize.css';
import history from 'utils/history';
import App from './containers/App';
import '!file-loader?name=[name].[ext]!./favicon.ico';
import GlobalStyles from './global-styles';
import AppHeader from './components/AppHeader';
import configureStore from './configureStore';
import { client } from './api/gql/taxi-backend/v1/apolloClientState';

const store = configureStore();
const MOUNT_NODE = document.getElementById('app');
const root = createRoot(MOUNT_NODE);

root.render(
  <ApolloProvider client={client}>
    <Provider store={store}>
      <ConnectedRouter history={history}>
        <GlobalStyles />
        <span>
          <AppHeader />
          <App />
        </span>
      </ConnectedRouter>
    </Provider>
  </ApolloProvider>
);
